import { Loading } from 'common/components/Loading/Loading';
import { ContentDispositionType } from 'common/hooks/useFiles';
import { useFilesDownload } from 'common/hooks/useFilesDownload';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const FileDownloadPage: React.FC = () => {
  const { downloadFile } = useFilesDownload();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      downloadFile({ id }, ContentDispositionType.INLINE, window);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return <Loading messages={[]} />;
};
